import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appInitializer } from './app-initializer';
import { LoginComponent } from './views/auth/login/login.component';
import { NotFoundComponent } from './views/errors/not-found/not-found.component';
import { ForgotPasswordComponent } from './views/auth/forgot-password/forgot-password.component';
import { SharedModule } from './core/shared.module';
import { LoginWithSocialComponent } from './views/auth/login-with-social/login-with-social.component';
// import { RegisterComponent } from './views/auth/register/register.component';
import { AuthComponent } from './views/auth/auth-wrapper.component';
import { authInterceptor } from './core/auth/auth.interceptor';
import { ResetPasswordComponent } from './views/auth/reset-password/reset-password.component';
import { serverErrorInterceptor } from './core/interceptors/server-error.interceptor';
import { MaterialModule } from './material/material.module';
import { ErrorDirective } from './standalone/error/error.directive';
import { ConfirmationComponent } from './core/modules/confirmation/confirmation.component';

import * as Sentry from "@sentry/angular";

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    LoginComponent,
    NotFoundComponent,
    ForgotPasswordComponent,
    LoginWithSocialComponent,
    ResetPasswordComponent,
    ConfirmationComponent,
    // RegisterComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    MaterialModule,
    SharedModule,
    BrowserAnimationsModule,
    ErrorDirective
  ],
  providers: [
    provideAppInitializer(appInitializer),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    provideHttpClient(withInterceptors([
      authInterceptor,
      serverErrorInterceptor,
    ])),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
